import  Home_cb  from './../../Banners/home.jpg'
import  Contact_cb  from './../../Banners/contact.jpg'
import  Individual_cb  from './../../Banners/home.jpg'
import  Pronounciation_cb  from './../../Banners/pronounciation.jpg'
import  Book_cb  from './../../Banners/home.jpg'
import  Resources_cb  from './../../Banners/resources.jpg'
import  Testimonial_cb  from './../../Banners/testimonials.jpg'

export const contact_banner_data = [
    {
        id: 1,
        page: 'Home',
        image: Home_cb,
        position: '45%',
    },
    {
        id: 2,
        page: 'Contact',
        image: Contact_cb,
        position: '0%',
    },
    {
        id: 3,
        page: 'Individual',
        image: Individual_cb,
        position: '45%',
    },
    {
        id: 4,
        page: 'Pronounciation',
        image: Pronounciation_cb,
        position: '45%',
    },
    {
        id: 5,
        page: 'Book',
        image: Book_cb,
        position: '45%',
    },
    {
        id: 6,
        page: 'Resources',
        image: Resources_cb,
        position: '40%',
    },
    {
        id: 7,
        page: 'Testimonial',
        image: Testimonial_cb,
        position: '5%',
    }
]